var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttributeMajorDonorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6169 6.17089C11.664 6.00172 11.5407 5.83315 11.3698 5.83315H6.63023C6.4593 5.83315 6.33597 6.00172 6.38312 6.1709L8.75289 14.6737C8.82413 14.9293 9.17587 14.9293 9.2471 14.6737L11.6169 6.17089Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2137 4.83294C11.4 4.83294 11.5245 4.63522 11.4484 4.4601L9.57843 0.156605C9.53703 0.0613311 9.44513 0 9.34376 0H8.65639C8.55503 0 8.46313 0.0613313 8.42173 0.156605L6.55178 4.4601C6.47569 4.63522 6.60013 4.83294 6.78644 4.83294H11.2137Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55539 15.8988C7.73101 16.1253 8.0816 15.9383 8.0032 15.6599L5.28938 6.02395C5.25752 5.91081 5.15688 5.83297 5.04247 5.83297H0.284936C0.0694883 5.83297 -0.050392 6.08949 0.0840331 6.26286L7.55539 15.8988Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9579 5.83315C12.8435 5.83315 12.7429 5.911 12.711 6.02414L9.9972 15.6601C9.9188 15.9384 10.2694 16.1255 10.445 15.899L17.9164 6.26304C18.0508 6.08967 17.9309 5.83315 17.7155 5.83315H12.9579Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6457 4.67635C12.6871 4.77161 12.779 4.83294 12.8804 4.83294H17.7425C17.954 4.83294 18.075 4.58457 17.9485 4.40996L14.957 0.279244C14.8945 0.192837 14.8121 0.122409 14.7164 0.0738329C14.6208 0.0252571 14.5147 -5.76401e-05 14.4071 9.85476e-08H11.01C10.8237 9.85476e-08 10.6993 0.19773 10.7754 0.372853L12.6457 4.67635Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11963 4.83294C5.22099 4.83294 5.3129 4.7716 5.35429 4.67633L7.22418 0.372833C7.30027 0.197712 7.17583 9.85476e-08 6.98952 9.85476e-08H3.59286C3.48528 -5.76401e-05 3.37924 0.0252571 3.28359 0.0738329C3.18795 0.122409 3.10546 0.192837 3.04302 0.279244L0.0514612 4.40996C-0.0749904 4.58457 0.0460229 4.83294 0.257546 4.83294H5.11963Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeMajorDonorIcon);
export default __webpack_public_path__ + "static/media/attribute-major-donor-icon.d66b44ed06c6202611a218fe2e47bf57.svg";
export { ForwardRef as ReactComponent };